import type { SignInOutput } from "aws-amplify/auth"
import type { SignInStepOutcome } from "./sign-in-step.types"

export const handleSignInStep = (result: SignInOutput): SignInStepOutcome => {
  const { signInStep } = result.nextStep

  switch (signInStep) {
    case "DONE":
      return "done"

    case "CONFIRM_SIGN_IN_WITH_TOTP_CODE":
      return { step: "mfa-code", method: "totp" }

    case "CONFIRM_SIGN_IN_WITH_SMS_CODE":
      return { step: "mfa-code", method: "sms" }

    case "CONFIRM_SIGN_IN_WITH_EMAIL_CODE":
      return { step: "mfa-code", method: "email" }

    case "CONTINUE_SIGN_IN_WITH_MFA_SELECTION": {
      const allowedMethods =
        "allowedMFATypes" in result.nextStep
          ? ((result.nextStep.allowedMFATypes as string[]) ?? [])
          : []
      return { step: "mfa-selection", allowedMethods }
    }

    case "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED":
      return { step: "new-password-required" }

    case "CONFIRM_SIGN_UP":
      return "confirm-sign-up"

    case "RESET_PASSWORD":
      return "reset-password"

    case "CONTINUE_SIGN_IN_WITH_TOTP_SETUP":
    case "CONTINUE_SIGN_IN_WITH_EMAIL_SETUP":
    case "CONTINUE_SIGN_IN_WITH_MFA_SETUP_SELECTION":
      return {
        step: "error",
        message:
          "MFA setup is required but cannot be completed here. Please contact support.",
      }

    case "CONFIRM_SIGN_IN_WITH_PASSWORD":
    case "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE":
    case "CONTINUE_SIGN_IN_WITH_FIRST_FACTOR_SELECTION":
      return {
        step: "error",
        message: "Unexpected authentication challenge. Please contact support.",
      }

    default:
      return {
        step: "error",
        message: `Unhandled sign-in step: ${signInStep}. Please try again or contact support.`,
      }
  }
}
